export enum IPermission {
  COMMERCIAL = 'COMMERCIAL',
  ADMIN = 'ADMIN',
  TECHNICIAN = 'TECHNICIAN',
  BIVISITOR = 'BIVISITOR',
  FRANCHISEE = 'FRANCHISEE',
}
